<template>
	<div></div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
	name: 'login',
	data() {
		return {};
	},
	created() {
		console.log('ceshi',wx)
		if (this.getParameterByName('code')) {
			console.log(wx);
			/**重新跳回小程序的方法*/
			wx.miniProgram.redirectTo({
				url: `/pages/login/login?code=${this.getParameterByName('code')}&a=${wx}`
			});
		} else {
			alert('售后哥哥');
		}
	},
	methods: {
		getParameterByName(name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			//匹配所有符合条件的，并取最后一个
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'g');
			var results = url.match(regex);
			var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : '';

			var finalResults = regex.exec(tempResults);
			if (!finalResults) return '';
			if (!finalResults[2]) return '';
			return decodeURIComponent(finalResults[2].replace(/\+/g, ' '));
		}
	}
};
</script>

